module.exports = __webpack_public_path__ + "static/media/Share.f93282d4.png";